module.exports = __webpack_public_path__ + "images/index/01.1390858.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/Quanta/01.jpg
// module id = B7sb
// module chunks = 21